import { render, staticRenderFns } from "./FooterCredits.vue?vue&type=template&id=a277880e&"
import script from "./FooterCredits.vue?vue&type=script&lang=js&"
export * from "./FooterCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterCredit: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterCredit.vue').default})
